<template>
  <el-date-picker
    v-model="value"
    :placeholder="placeholder"
    :clearable="clearable"
    :size="size"
    :type="type"
    :format="format"
    range-separator="至"
    start-placeholder="开始"
    end-placeholder="结束"
    :value-format="valueFormat"
    :picker-options="type === 'daterange' ? pickerOptions : ''"
    :style="datePickerStyle"
    @change="change"
  />
</template>

<script>
import moment from 'moment';

export default {
  name: 'nf-date-picker',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: Array,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '',
    },
    valueFormat: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    datePickerStyle() {
      if (this.formData && this.formData.width) {
        return { width: this.formData.width };
      }
      return {};
    },
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', [moment().format('yyyy-MM-DD'), moment().format('yyyy-MM-DD')]);
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(1, 'day').format('yyyy-MM-DD'),
                moment().subtract(1, 'day').format('yyyy-MM-DD'),
              ]);
            },
          },
          {
            text: '本周',
            onClick(picker) {
              picker.$emit('pick', [
                moment().startOf('week').add(1, 'day').format('YYYY-MM-DD'),
                moment().endOf('week').add(1, 'day').format('YYYY-MM-DD'),
              ]);
            },
          },
          {
            text: '上周',
            onClick(picker) {
              picker.$emit('pick', [
                moment().subtract(1, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD'),
                moment().subtract(1, 'week').endOf('week').add(1, 'day').format('YYYY-MM-DD'),
              ]);
            },
          },
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [
                moment().startOf('month').format('YYYY-MM-DD'),
                moment().endOf('month').format('YYYY-MM-DD'),
              ]);
            },
          },
          {
            text: '本季度',
            onClick(picker) {
              picker.$emit('pick', [
                moment().startOf('Q').format('YYYY-MM-DD'),
                moment().endOf('Q').format('YYYY-MM-DD'),
              ]);
            },
          },
          {
            text: '本年',
            onClick(picker) {
              picker.$emit('pick', [
                moment().year(moment().year()).startOf('year').format('YYYY-MM-DD'),
                moment().year(moment().year()).endOf('year').format('YYYY-MM-DD'),
              ]);
            },
          },
        ],
      },
    };
  },
  methods: {
    change(e) {
      let time = [];
      if (e) {
        time = e;
      }
      this.value = time;
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: time,
      });
      if (!e || e == null) {
        this.$store.dispatch(`${this.storeModelName}/getList`);
      }
    },
  },
};
</script>
